module.exports = __webpack_public_path__ + "static/media/_right_quote.5eac31ca.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/alphabet/_right_quote.jpg
// module id = 59
// module chunks = 0